/**
 * VIB-642 PR 6.4: Sentry-info-kort.
 *
 * Vi viser et statisk kort med lenke til Sentry-dashboardet for prosjektet.
 * Vi har bevisst ingen direktekall mot Sentry sin API herfra — den krever
 * en personlig auth-token og er ikke trygt å eksponere i klienten. Erik kan
 * legge inn et secret-token og en edge function senere hvis vi vil ha
 * unresolved-count direkte i UI.
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";

const SENTRY_PROJECT_URL =
  "https://vibbing.sentry.io/projects/sentry-revehiet/?statsPeriod=24h";
const SENTRY_ISSUES_URL =
  "https://vibbing.sentry.io/issues/?project=sentry-revehiet&statsPeriod=24h&query=is%3Aunresolved";

export function SentryInfoCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Sentry</CardTitle>
        <p className="text-sm text-muted-foreground">
          Errors + performance. Alerts videresendes til{" "}
          <code className="font-mono text-xs">#vibbing-alerts</code> i Slack.
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-sm">
          <div className="flex items-baseline justify-between border-b pb-2">
            <span className="text-muted-foreground">Organisasjon</span>
            <span className="font-medium">vibbing (de.sentry.io)</span>
          </div>
          <div className="flex items-baseline justify-between border-b py-2">
            <span className="text-muted-foreground">Prosjekt</span>
            <span className="font-mono text-xs">sentry-revehiet</span>
          </div>
          <div className="flex items-baseline justify-between pt-2">
            <span className="text-muted-foreground">Period</span>
            <span>Siste 24 timer</span>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 pt-2">
          <Button asChild variant="default" size="sm">
            <a href={SENTRY_ISSUES_URL} target="_blank" rel="noopener noreferrer">
              <SrIcon name="external-link" size={14} className="mr-1.5" />
              Åpne unresolved issues
            </a>
          </Button>
          <Button asChild variant="outline" size="sm">
            <a href={SENTRY_PROJECT_URL} target="_blank" rel="noopener noreferrer">
              <SrIcon name="external-link" size={14} className="mr-1.5" />
              Sentry-dashboard
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
